import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { VND_UNIT } from '../../../constants'

const FirstColumnCell = ({
  val,
  rowSpanFirstCell,
  isFirstGroupRow,
  currency,
  unitName,
  isDynamicReport,
  backgroundColor,
}) => {
  let unit = val.unit
  if (unit === VND_UNIT) unit = `${unitName} ${currency}`

  return (
    <td
      rowSpan={rowSpanFirstCell}
      style={{
        backgroundColor,
      }}
    >
      <Element className="flexColumn">
        <span className={isDynamicReport ? '' : 'fw600'}>
          {val.ratioName}
          <Element
            elementName="span"
            style={{ color: '#9C9C9C', marginLeft: 4 }}
          >
            ({unit})
          </Element>
        </span>
        {!isDynamicReport && (
          <Element
            elementName="span"
            style={{
              color: isFirstGroupRow ? '#9C9C9C' : '#2C73E8',
              marginTop: 4,
            }}
          >
            <Translate value={'portfolio.finance.SHOW_ON_CHART'} />
          </Element>
        )}
      </Element>
    </td>
  )
}

export default FirstColumnCell
